/**
 * Work Item Yönetimi — Şantiye Seçim Ekranı (Faz 29)
 */
import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Shell from "@/components/Shell";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { useSites } from "@/context/SiteContext";
import { searchMatchTR } from "@/lib/textFormat";
import {
  MapPin, MagnifyingGlass, CaretRight, Package,
} from "@phosphor-icons/react";

export default function WorkItemsIndex() {
  const { sites } = useSites();
  const [q, setQ] = useState("");
  const visible = useMemo(() => {
    const active = (sites || []).filter((s) => s.status !== "arsiv");
    if (!q.trim()) return active;
    return active.filter((s) =>
      searchMatchTR(q, [s.code, s.name, s.city, s.district].filter(Boolean).join(" "))
    );
  }, [sites, q]);
  return (
    <Shell>
      <div className="space-y-6" data-testid="wi-index-page">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-md bg-[#95C11F]/15 flex items-center justify-center">
              <Package size={22} weight="duotone" className="text-[#556B10]" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-[#1B4776]">Work Item Yönetimi</h1>
              <p className="text-sm text-slate-500">
                WBS × Lokasyon operasyon kayıtları — bir şantiye seçin.
              </p>
            </div>
          </div>
          <div className="relative">
            <MagnifyingGlass size={16} weight="bold"
              className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <Input value={q} onChange={(e) => setQ(e.target.value)}
              placeholder="Şantiye ara..." className="pl-9 w-72"
              data-testid="wi-index-search" />
          </div>
        </div>
        {visible.length === 0 ? (
          <Card className="p-10 text-center text-slate-500">
            {q ? "Arama sonucu bulunamadı." : "Henüz aktif şantiye bulunmuyor."}
          </Card>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {visible.map((s) => (
              <Link key={s.id} to={`/proje/${s.id}/work-items`}
                    data-testid={`wi-index-site-${s.id}`} className="group">
                <Card className="p-5 hover:border-[#95C11F] hover:shadow-lg transition-all cursor-pointer border-l-4 border-l-[#95C11F]/40 hover:border-l-[#95C11F]">
                  <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0 flex-1">
                      <div className="text-xs font-mono font-bold text-[#1B4776] tracking-wider uppercase">
                        {s.code}
                      </div>
                      <div className="mt-1 text-base font-bold text-[#0F172A] group-hover:text-[#556B10] transition-colors line-clamp-2">
                        {s.name}
                      </div>
                      {(s.city || s.district) && (
                        <div className="mt-2 flex items-center gap-1.5 text-xs text-slate-500">
                          <MapPin size={13} weight="fill" className="text-[#1B4776]/60" />
                          <span>{[s.district, s.city].filter(Boolean).join(", ")}</span>
                        </div>
                      )}
                    </div>
                    <div className="p-2 rounded-full bg-slate-50 group-hover:bg-[#95C11F] transition-colors">
                      <CaretRight size={16} weight="bold"
                        className="text-slate-400 group-hover:text-white transition-colors" />
                    </div>
                  </div>
                  <div className="mt-4 pt-3 border-t border-slate-100 text-[11px] text-slate-500 inline-flex items-center gap-1">
                    <Package size={13} weight="bold" />
                    WBS × Lokasyon operasyon kayıtları
                  </div>
                </Card>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Shell>
  );
}
